import image from "../../assets/images/auth.png"

const RolelessUser = () => {
    return (
        <>
            <div className="blocked-container">
                <div>
                    <img src={image} alt="unauthorized" width="50px" />
                    <h3>403 Forbidden Access</h3>
                    <p>You are authorized but not assigned a role. Please contact the administrator for access.</p>
                </div>
            </div>        
        </>
    )
}

export default RolelessUser